import { Injectable } from '@angular/core';
import { GlobalVar } from './globalvar';

@Injectable({
  providedIn: 'root'
})
export class GlobalService extends GlobalVar {

  constructor() {
    super();
  }

}
